import { createFileRoute } from '@tanstack/react-router';

import { UnitsPage } from '@/features/units/components/UnitsPage';

export const Route = createFileRoute('/admin/units')({
  component: UnitsPage,
});
